import React, { PureComponent } from 'react';

interface Props {
  size: number;
}

class BambooHR extends PureComponent<Props> {
  render() {
    const { size = 24, ...otherProps } = this.props;
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        {...otherProps}
      >
        <path d="M17.5227017,8.79919479 C20.9984744,8.79919479 24,11.7756831 24,15.2388101 C24,18.9683574 21.1222206,21.8703155 17.3214441,21.8703155 C13.8711685,21.8703155 10.8645435,19.4573567 10.8645435,15.5848193 L10.8645435,3 L12.8625009,3 L12.8631809,10.6897674 L13.1001344,10.442907 C13.9697576,9.58665233 15.2095994,8.79919479 17.5227017,8.79919479 Z M17.3214441,20.0637159 C20.1560483,20.0637159 21.9568277,18.062191 21.9568277,15.4226064 C21.9568277,12.996158 20.2549772,10.6796501 17.366659,10.6796501 C14.4786809,10.6796501 12.6877604,12.8403527 12.6877604,15.471169 C12.6877604,18.1006365 14.8118437,20.0637159 17.3214441,20.0637159 Z M6.85805591,4.51930405 C8.34912977,6.08140397 8.50585231,6.95418346 9.03517331,8.47041862 L9.92213451,11.3528167 C9.92213451,11.3528167 9.04741193,11.1899294 8.33077182,11.0826868 C7.49956443,10.9575704 7.13172541,10.8351519 6.07512313,10.4078677 C5.01784093,9.98058344 4.06186744,8.93547384 3.12459187,7.76996924 C2.18765626,6.60379015 0,4.77156026 0,4.77156026 C0,4.77156026 0.676524624,4.81607605 1.36222823,4.985371 C1.92418561,5.1246515 3.38738259,5.59543981 4.89681442,6.37345461 C5.23167711,6.54544747 5.41729643,6.65707421 5.74739965,6.86009325 C6.24918374,7.16765697 6.77714491,7.62630461 7.28232863,8.13486391 C7.87624246,8.73211757 8.39638451,9.21234864 8.84037502,9.74687549 C8.3569489,8.86397877 7.10384851,5.6851459 4.65408146,3.06141157 C4.4140682,2.80443399 6.34743279,3.98376548 6.85805591,4.51930405 Z" />
      </svg>
    );
  }
}

export default BambooHR;
